import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Teach tailwind-merge about our semantic font-size tokens so they don't get
// misclassified as text-color classes and drop the built-in foreground.
const twMerge = extendTailwindMerge({
	extend: {
		classGroups: {
			'font-size': [
				{
					text: [
						'headline-xxl',
						'headline-xl',
						'headline-lg',
						'headline-md',
						'headline-sm',
						'headline-xs',
						'title-xl',
						'title-lg',
						'title-md',
						'title-sm',
						'title-xs',
						'body-xl',
						'body-lg',
						'body-md',
						'body-sm'
					]
				}
			]
		}
	}
});

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
